import { assignInput, BaseModel } from '../../base.model';
import { EquipmentTypeToCompanyDto } from './EquipmentTypeToCompanyDto';
import { EquipmentTypeToRequirementDto } from './EquipmentTypeToRequirementDto';

export class EquipmentTypeDto extends BaseModel {
  public EquipmentTypeID: string;
  public Name: string;
  public bActive: boolean;

  Companies: EquipmentTypeToCompanyDto[] = [];
  Requirements: EquipmentTypeToRequirementDto[] = [];

  constructor(o: any = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
